import {BaseContainerModel} from '../../base-container.model';
import * as fromDatatype from '../../../datatype-library';

export class ClaimCycleCheckingSampleHdrBodyRequestContainerModel extends BaseContainerModel {
  name: fromDatatype.VarcharDatatypeInterface;
  sample_size: fromDatatype.IntegerDatatypeInterface;
  cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  prev_sample_hdr_guid: fromDatatype.GuidDataFieldInterface;
  exclude_previous_samples: boolean;
  number_of_random_employees: fromDatatype.IntegerDatatypeInterface;
  amount_less_than: fromDatatype.IntegerDatatypeInterface;
  amount_greater_than: fromDatatype.IntegerDatatypeInterface;
  sampling_level: fromDatatype.IntegerDatatypeInterface;
  claim_statuses: string[];
  claim_item_guids: string[];
  claim_types: string[]; // CHARGEABLE,NON_CHARGEABLE
  is_flag: boolean;
  type: fromDatatype.VarcharDatatypeInterface;
  historical_claim_cycle_hdr_guids: string[];
  branch_guids: string[]; // Empty means select all possible branches under claim cycle
  claim_item_categories: string[];
  finance_checking_date_from: fromDatatype.VarcharDatatypeInterface;
  finance_checking_date_to: fromDatatype.VarcharDatatypeInterface;
  number_of_claims_per_category: fromDatatype.IntegerDatatypeInterface;
}
